<template>
  <div>
    <div class="modal-pdv show modal-full" id="modalFinalizar" tabindex="0" v-if="modal > 0" :class="{modalCaixa}">
      <div class="modal-pdv-content">
        <div class="container-fluid" v-if="comanda.status === '1'">
          <div class="row no-gutters">
            <div class="col-lg-4 d-none d-lg-block pr-md-2">
              <div class="border rounded height-90">
                <table class="table table-sm">
                  <tr class="bg-light small">
                    <th class="text-left border-0" style="width: 25px" v-if="!isPedido">&nbsp;</th>
                    <th class="text-left border-0">Produto</th>
                    <th class="text-center border-0" style="width:85px">Total</th>
                  </tr>
                  <tr v-for="(p, index) in produtos">
                    <td v-if="!isPedido">
                      <input type="checkbox" :id="'finalizar' + index" @change="changeSelecionados(p.produto)" :checked="selecionados.includes(p.produto.id_comanda_produto)"
                             :disabled="p.disabled || p.id_voucher || (totalRecebido === totalPagar)">
                    </td>
                    <td class="text-left small">
                      <label class="d-block m-0 pointer" :for="'finalizar' + index" :style="p.disabled ? 'text-decoration: line-through' : ''">
                        <b v-show="p.produto.id_medida === '1'">{{p.quantidade | qtd}}x</b>
                        <b v-show="p.produto.id_medida !== '1'">{{p.quantidade | medida}}</b>
                        {{p.produto.nome_produto}} {{p.divisoes.length > 0 ? "(" + normalizeDivisoes(p.divisoes) + ")" : ""}}
                        <span v-show="p.produto.principal === '0' && p.produto.nome_tabela"><b>{{' - ' + p.produto.nome_tabela}}</b></span>
                        <span class="badge badge-warning ml-1" v-if="p.id_voucher"><i class="fa fa-ticket-alt mr-1"></i> Voucher</span>
                        <div v-if="p.produto.observacao">Obs: <b>{{p.produto.observacao}}</b></div>
                        <div v-if="p.nome_cliente">Cliente: <b>{{p.nome_cliente}}</b></div>
                      </label>
                    </td>
                    <td class="text-center">{{p.valor_total | valor}}</td>
                  </tr>
                </table>
              </div>
              <div class="d-flex justify-content-between align-items-center" style="height: 38px" v-if="!isPedido">
                <div>Total selecionado: <b>{{totalSelecionados | valor}}</b></div>
              </div>
            </div>
            <div class="col-lg-4">
              <h6 class="mb-3 font-weight-bold text-center d-lg-none mb-3">Finalizar Venda</h6>
              <div class="row no-gutters">
                <div class="col-lg-8 pr-lg-1">
                  <div class="card-pagamento">
                    <label class="mb-0">Valor do pagamento</label>
                    <div class="d-lg-flex justify-content-between align-items-center">
                      <money v-model="valor_pagamento" class="form-control" id="inserirPagamento"
                             @keydown.enter.native="incluirPagamentoForm()"
                             @focus.native="$helpers.selectElement('inserirPagamento')"
                             :disabled="totalRecebido === totalPagar"/>
                      <button class="btn btn-info ml-lg-1" @click="incluirPagamentoForm()" :disabled="btnFinalizar" title="Adicionar pagamento">
                        <i class="fa fa-plus"></i><span class="d-sm-none ml-2">Adicionar</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 pl-lg-1 mb-3 mb-lg-0">
                  <label class="mb-0 text-center">Dividir</label>
                  <div class="d-flex">
                    <input type="number" v-model="qtdDividir" class="form-control" placeholder="Nº" min="1" @keyup.enter="selDividir" :disabled="totalRecebido === totalPagar"/>
                    <button :disabled="btnFinalizar" class="btn btn-third ml-1 text-nowrap" title="Dividir a quantidade de pagantes" @click="selDividir">
                      <i class="fa fa-divide"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block mt-2">
                <div class="row no-gutters text-center">
                  <div class="col-6 col-sm-3 pr-1 mb-2 small">
                    <button id="btnDinheiro" :disabled="btnFinalizar" class="btn btn-block btn-primary m-0 py-2" @click="togglePagamento('1')">
                      <i class="fa fa-money-bill"></i>
                      <span class="small d-block mt-2">Dinheiro</span>
                    </button>
                  </div>
                  <div class="col-6 col-sm-3 pr-1 mb-2 small" v-if="pagamentosCartao.length">
                    <button id="btnCartao" :disabled="btnFinalizar" class="btn btn-block btn-secondary m-0 py-2" @click="openCartao()">
                      <i class="fa fa-credit-card"></i>
                      <span class="small d-block mt-2">Cartão</span>
                    </button>
                  </div>
                  <div class="col-6 col-sm-3 pr-1 mb-2 small">
                    <button id="btnPix" :disabled="btnFinalizar" class="btn btn-block btn-pix m-0 py-2" @click="openPix()">
                      <img src="../../../assets/icons/pix.png" alt="Pix" style="width: 20px">
                      <span class="small d-block mt-2">Pix</span>
                    </button>
                  </div>
                  <div class="col-6 col-sm-3 mb-2 small">
                    <button id="btnPagOutros" :disabled="btnFinalizar" class="btn btn-block btn-warning m-0 py-2" @click="openOutros()">
                      <i class="fa fa-coins"></i>
                      <span class="small d-block mt-2">Outros</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="height-50 border rounded">
                <table class="table table-borderless table-hover table-sm mb-0">
                  <thead class="bg-third text-white small">
                    <tr>
                      <th class="font-weight-normal">Pagamentos da venda</th>
                      <th class="text-center" style="width: 50px">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr v-for="p in dados.pagamentos">
                    <td class="pointer" @click="editarPagamento(p)">
                      <div>{{p.valor | valor}}</div>
                      <div class="small" :title="p.observacao" v-if="p.id_voucher">
                        <i class="fa fa-ticket-alt text-warning"></i> {{p.observacao}}
                      </div>
                      <div class="text-ellipsis small" :title="p.nome_pagamento" style="width: 160px" v-else>{{ p.nome_pagamento }}</div>
                      <div class="small" :title="p.observacao" v-if="p.observacao && !p.id_voucher"><b>Obs:</b> {{ p.observacao }}</div>
                    </td>
                    <td class="text-nowrap text-right" v-if="!p.transacao">
                      <button class="btn btn-sm btn-primary mr-1" @click="editarPagamento(p, true)" title="Editar Pagamento" style="width: 36px">
                        <i class="fa" :class="p.transacao ? 'fa-eye' : 'fa-pencil-alt'"></i>
                      </button>
                      <button class="btn btn-sm btn-dark" @click="removerPagamento(p)" title="Remover Pagamento" style="width: 36px">
                        <i class="fa fa-trash-alt"></i>
                      </button>
                    </td>
                    <td class="text-nowrap text-right" v-else>
                      <button class="btn btn-sm text-dark" @click="cancelarTransacao(p)" title="Cancelar Transação" style="width: 36px">
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="d-md-none text-center my-3" v-if="!dados.pagamentos.length">Nenhum pagamento informado</div>
              </div>
              <div class="py-0 p-lg-2 d-flex justify-content-between align-items-center">
                <div>Falta receber: </div>
                <div class="text-right">
                  <span v-show="totalRecebido < totalPagar"><b>{{(totalPagar - totalRecebido) | valor}}</b></span>
                  <span v-show="totalRecebido >= totalPagar"><b>0,00</b></span>
                </div>
              </div>
              <hr class="d-lg-none">
            </div>
            <div class="col-lg-4 pl-lg-2">
              <div class="row no-gutters">
                <div class="col-sm-12 mb-2" v-if="isPedidoEntrega">
                  <label class="mb-0">Taxa de entrega</label>
                  <div class="d-flex">
                    <money v-model="frete" id="valorFrete" class="form-control" placeholder="Taxa de Entrega" @keyup.enter.native="toggleFrete()" :disabled="dados.frete > 0"/>
                    <button :class="dados.frete > 0 ? 'btn-third' : 'btn-info'" class="btn ml-1" style="width: 70px"
                            @click="toggleFrete(true)" :disabled="(totalRecebido === totalPagar) || frete <= 0" :title="dados.frete > 0 ? 'Remover Taxa de Entrega' : 'Adicionar Taxa de Entrega'">
                      <i class="fa fa-times" v-if="dados.frete > 0"></i>
                      <i class="fa fa-plus" v-else></i>
                    </button>
                    <button class="btn ml-1 btn-warning" style="width: 70px" title="Consultar taxas de entrega"
                            @click="openZonas" :disabled="totalRecebido === totalPagar" v-if="zonas.length">
                      <i class="fa fa-map-marker-alt"></i>
                    </button>
                  </div>
                </div>
                <div class="col-sm-12 mb-2" v-if="!isPedido && $store.state.dataUser.status_fidelidade === '1'">
                  <validar-voucher :id_comanda="comanda.id_comanda" :disabled="totalRecebido === totalPagar" @addVoucher="addVoucher"/>
                </div>
                <div class="col-sm-12 mb-2" v-if="hasService && taxa > 0">
                  <label class="mb-0">{{ impostoNfe ? 'Imposto' : 'Taxa serviço' }}</label>
                  <div class="d-flex">
                    <div class="form-control" style="background-color: #eaecf4">{{taxa}}%</div>
                    <button :class="dados.taxa_servico > 0 ? 'btn-third' : 'btn-info'" class="btn ml-1" style="width: 70px"
                            @click="toggleTaxaServico(dados.taxa_servico > 0)" :disabled="totalRecebido === totalPagar">
                      <i class="fa fa-minus" v-if="dados.taxa_servico > 0"></i>
                      <i class="fa fa-plus" v-else></i>
                    </button>
                  </div>
                </div>
                <div class="col-sm-12 mb-2" v-if="hasService && $store.state.pdv.estacionamento > 0">
                  <label class="mb-0">Estacionamento</label>
                  <div class="d-flex">
                    <money v-model="estacionamento" class="form-control" @keyup.enter.native="toggleParking" :disabled="dados.estacionamento > 0"/>
                    <button class="btn btn-info ml-1" style="width: 70px"
                            :class="dados.estacionamento > 0 ? 'btn-third' : 'btn-info'" :disabled="totalRecebido === totalPagar" @click="toggleParking">
                      <i class="fa fa-minus" v-if="dados.estacionamento > 0"></i>
                      <i class="fa fa-plus" v-else></i>
                    </button>
                  </div>
                </div>
                <div class="col-sm-12 mb-2" v-if="hasService && $store.state.pdv.cover > 0">
                  <label class="mb-0">Couvert artístico <small>({{cover | valor}})</small></label>
                  <div class="d-flex">
                    <div class="form-control bg-light">{{dados.cover > 0 ? `${(dados.cover / cover)}` : `Qtd Pessoas`}}</div>
                    <button class="btn btn-third ml-1" style="width: 70px"
                            @click="toggleCover(false)" :disabled="totalRecebido === totalPagar">
                      <i class="fa fa-minus"></i>
                    </button>
                    <button class="btn btn-info ml-1" style="width: 70px"
                            @click="toggleCover(true)" :disabled="totalRecebido === totalPagar">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 mb-3">
                  <label class="mb-0">Desconto ({{hasPercent ? '%' : 'R$'}})</label>
                  <div class="d-flex">
                    <the-mask :mask="['##%','#%']" id="descontoPercent" class="form-control mr-1" placeholder="%" v-model="percent" @keydown.enter.native="calcularDesconto" @focus.native="focusInput" :disabled="totalRecebido === totalPagar" v-if="hasPercent"/>
                    <money v-model="desconto" id="descontoValor" class="form-control mr-1" @keyup.enter.native="calcularDesconto" :disabled="dados.desconto > 0 || totalRecebido === totalPagar" v-else/>
                    <button class="btn btn-secondary mr-1" @click="togglePercent()" style="width: 70px" v-if="dados.desconto === 0">
                      <i class="fa fa-percentage" v-if="!hasPercent"></i>
                      <i class="fa fa-dollar-sign" v-else></i>
                    </button>
                    <button :class="dados.desconto > 0 ? 'btn-third' : 'btn-info'" class="btn" style="width: 70px"
                            @click="calcularDesconto" :disabled="(desconto > totalComanda)">
                      <i class="fa fa-minus" v-if="dados.desconto > 0"></i>
                      <i class="fa fa-plus" v-else></i>
                    </button>
                  </div>
                </div>
              </div>
              <div :class="dados.troco > 0.01 ? 'bg-third text-white' : 'border'" class="rounded p-2 mb-2">
                Troco
                <b class="float-right">{{dados.troco | valor}}</b>
              </div>
              <div class="border rounded p-2 d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div class="small">Produtos: </div>
                  <div class="small" v-if="taxa > 0">{{ impostoNfe ? 'Imposto' : 'Taxa de serviço' }}: </div>
                  <div class="small" v-if="dados.cover > 0">Couvert: </div>
                  <div class="small" v-if="isPedidoEntrega">Taxa de entrega: </div>
                  <div class="small" v-if="dados.estacionamento > 0">Estacionamento: </div>
                  <div class="small" v-if="dados.desconto > 0">Desconto: </div>
                  <div>Total a pagar: </div>
                </div>
                <div class="text-right">
                  <div class="small">{{totalComanda | valor}}</div>
                  <div class="small" v-if="taxa > 0">(+) {{dados.taxa_servico | valor}}</div>
                  <div class="small" v-if="dados.estacionamento > 0">(+) {{dados.estacionamento | valor}}</div>
                  <div class="small" v-if="dados.cover > 0">(+) {{dados.cover | valor}}</div>
                  <div class="small" v-if="isPedidoEntrega">(+) {{dados.frete | valor}}</div>
                  <div class="small" v-if="dados.desconto > 0">(-) {{dados.desconto | valor}}</div>
                  <div class="font-weight-bold"><b>{{totalPagar | valor}}</b></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid" v-else>
          <div class="row">
            <div class="col-md-6">
              <div class="height-100">
                <div class="card p-2 text-left mb-2">
                  <div class="h6 mb-0 font-weight-bold">
                    <span class="mr-1" v-if="comanda.tipo_comanda === '1'">MESA {{comanda.mesa}}</span>
                    <span class="mr-1" v-else-if="comanda.tipo_comanda === '2'">Delivery</span>
                    <span class="mr-1" v-else-if="comanda.tipo_comanda === '3'">COMANDA {{comanda.ref_comanda}}</span>
                    <span class="mr-1" v-else>Venda Rápida</span>
                    <span class="badge badge-success" v-if="comanda.status === '1'">Aberta</span>
                    <span class="badge badge-dark" v-if="comanda.status === '2'">Fechada</span>
                    <span class="badge badge-danger" v-if="comanda.status === '3'">Cancelada</span>
                  </div>
                  <div v-if="comanda.cliente">
                    {{comanda.cliente.nome_cliente}}
                  </div>
                  <div class="small">
                    {{comanda.id_comanda ? ("Venda: "  + comanda.id_contador + " - " + comanda.data_comanda) : 'Nova Venda'}}
                  </div>
                </div>
                <div class="text-center mb-2">
                  <div class="border rounded py-2 mb-3" v-if="dados.estacionamento > 0">
                    <h5 class="font-weight-bold m-0">{{dados.estacionamento | valor}}</h5>
                    <h6 class="small m-0">Estacionamento</h6>
                  </div>
                  <div class="border rounded py-2 mb-2" v-if="dados.cover > 0">
                    <h5 class="font-weight-bold m-0">{{dados.cover | valor}}</h5>
                    <h6 class="small m-0">Couvert</h6>
                  </div>
                  <div class="border rounded py-2 mb-2" v-if="comanda.taxa_servico > 0">
                    <h5 class="font-weight-bold m-0">{{comanda.taxa_servico | valor}}</h5>
                    <h6 class="small m-0">{{ impostoNfe ? 'Imposto' : 'Taxa de Serviço' }}</h6>
                  </div>
                  <div class="border rounded py-2 mb-2" v-if="comanda.frete > 0">
                    <h5 class="font-weight-bold m-0">{{comanda.frete | valor}}</h5>
                    <h6 class="small m-0">Frete</h6>
                  </div>
                  <div class="border rounded py-2 mb-2" v-if="dados.desconto > 0">
                    <h5 class="font-weight-bold m-0">{{dados.desconto | valor}}</h5>
                    <h6 class="small m-0">Desconto</h6>
                  </div>
                  <div class="rounded bg-success text-white py-2 mb-2">
                    <h5 class="font-weight-bold m-0">{{totalRecebido | valor}}</h5>
                    <h6 class="small m-0">Total Recebido</h6>
                  </div>
                  <div class="rounded bg-primary text-white py-2 mb-2" v-if="dados.troco > 0">
                    <h5 class="font-weight-bold m-0">{{dados.troco | valor}}</h5>
                    <h6 class="small m-0">Troco</h6>
                  </div>
                </div>
                <div class="card">
                  <div class="table-responsive">
                    <table class="table table-sm mb-2">
                      <tr class="bg-light small">
                        <th>
                          Pagamento
                        </th>
                        <th style="width: 120px">Valor</th>
                      </tr>
                      <tr v-for="p in comanda.pagamentos">
                        <td>
                          {{p.nome_pagamento}}
                          <div class="small">{{p.observacao}}</div>
                        </td>
                        <td>{{p.valor | valor}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="border rounded height-100 mb-2">
                <table class="table table-sm">
                  <tr class="bg-light small">
                    <th class="text-left">Produto</th>
                    <th class="text-right" style="width:85px">Total</th>
                  </tr>
                  <tr v-for="(p) in produtos">
                    <td class="text-left small">
                      <div class="d-block m-0 py-2">
                        <b v-show="p.produto.id_medida === '1'">{{p.quantidade | qtd}}x</b>
                        <b v-show="p.produto.id_medida !== '1'">{{p.quantidade | medida}}</b>
                        {{p.produto.nome_produto}} {{p.divisoes.length > 0 ? "(" + normalizeDivisoes(p.divisoes) + ")" : ""}}
                        <span v-show="p.produto.principal === '0' && p.produto.nome_tabela"><b>{{' - ' + p.produto.nome_tabela}}</b></span>
                      </div>
                    </td>
                    <td class="text-right">{{p.valor_total | valor}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="fechar">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button v-show="comanda.status === '1'" id="btnFinalizar" :disabled="load"
                  class="btn btn-success p-3" @click="finalizaVenda"
                  @keydown.tab="$helpers.focusElement('btnDinheiro')">
            <i class="fa fa-check mr-2"></i>
            <span v-if="isPedido">Finalizar Pedido</span>
            <span v-else>{{!btnFinalizar ? 'Salvar Venda' : 'Finalizar Venda'}}</span>
          </button>
          <button v-show="comanda.status !== '1'" id="btnComprovante"  class="btn btn-third p-3" @click="$emit('comprovante', comanda.id_comanda)">
            <i class="fa fa-print mr-2"></i>
            <span>Comprovante</span>
          </button>
        </div>
      </div>
    </div>

    <div class="modal-pdv modal-small show" id="modalOutrosPagamentos" tabindex="0" v-if="modal === 2">
      <div class="modal-pdv-content">
        <div class="container-fluid p-0">
          <h6 class="font-weight-bold text-center mb-0">Selecione um pagamento</h6>
          <hr>
          <div class="px-3">
            <input type="search" class="form-control" id="termPagamento" v-model="termPagamento" @keyup="pesquisarPagamentos" placeholder="Pesquisar"
                   @keyup.down="$helpers.focusElement('btnPag0')"
                   @keyup.esc="closeModal('btnPagOutros')"
                   @keydown.enter="selPagamento()"
            />
          </div>
          <div class="height-75 py-2">
            <div class="mx-3">
              <a href="javascript:" tabindex="0" class="d-flex border-bottom px-1 py-3 text-decoration-none text-dark align-items-center"
                 v-for="(p, index) in searchPagamentos" :id="'btnPag' + index"
                 @keyup.down="$helpers.focusElement('btnPag' + (index + 1))"
                 @keyup.up="index > 0 ? $helpers.focusElement('btnPag' + (index - 1)) : $helpers.focusElement('termPagamento')"
                 @keyup.esc="closeModal('btnPagOutros')"
                 @click="selPagamento(p)">
                <img :src="p.img_pagamento" alt="Pagamento" v-if="p.img_pagamento" class="img-pagamento mr-1">
                {{p.nome_pagamento}} <span class="badge badge-primary ml-1" v-if="pagEdit && pagEdit.id_pagamento === p.id_pagamento"><i class="fa fa-check"></i></span>
              </a>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="closeModal('btnPagOutros')">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
        </div>
      </div>
    </div>

    <div class="modal-pdv modal-small show" id="modalCartao" tabindex="0" v-if="modal === 3">
      <div class="modal-pdv-content">
        <div class="container-fluid text-center px-0">
          <div class="px-2 pb-3" :class="{'height-75': pagamentosCartao.length > 2}">
            <h6 class="mb-3 font-weight-bold">Selecione um cartão</h6>
            <div class="row no-gutters mt-3">
              <div class="col-6 p-1 small" :class="{'col-md-4': pagamentosCartao.length > 2}" v-for="(p, index) in pagamentosCartao">
                <button class="btn btn-block m-0 py-2 btn-pagamento" :id="`btnCartao${index}`" :class="forma_pagamento === p.id_pagamento ? 'btn-primary' : 'border btn-light'"
                        @click="togglePagamento(p.id_pagamento)"
                        @keyup.esc="closeModal('btnCartao')">
                  <img :src="p.img_pagamento" alt="Pagamento" v-if="p.img_pagamento" class="img-pagamento">
                  <i class="fa fa-credit-card" v-else></i>
                  <span class="small d-block mt-2">{{ p.nome_pagamento }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="closeModal('btnCartao')">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="modal === 6" id="modalPix" class="modal-pdv modal-small show" tabindex="0">
      <div class="modal-pdv-content">
        <div class="container-fluid text-center px-0">
          <div :class="{'height-75': pagamentosPix.length > 2}" class="px-2 pb-3">
            <h6 class="mb-3 font-weight-bold">Selecione um Pix</h6>
            <div class="row no-gutters mt-3">
              <div v-for="(p, index) in pagamentosPix" :class="{'col-md-4': pagamentosPix.length > 2}" class="col-6 p-1 small">
                <button :id="`btnPix${index}`" :class="forma_pagamento === p.id_pagamento ? 'btn-primary' : 'border btn-light'" class="btn btn-block m-0 py-2 btn-pagamento"
                        @click="togglePagamento(p.id_pagamento)"
                        @keyup.esc="closeModal('btnPix')">
                  <img v-if="p.img_pagamento" :src="p.img_pagamento" alt="Pagamento" class="img-pagamento">
                  <img v-else alt="Pix" src="../../../assets/icons/pix.png" style="width: 20px">
                  <span class="small d-block mt-2">{{ p.nome_pagamento }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="closeModal('btnPix')">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
        </div>
      </div>
    </div>

    <div v-show="modal === 4">
      <cliente ref="finCliente" @retorno="selecionarCliente"/>
    </div>

    <div class="modal-pdv modal-small show" id="modalZonas" tabindex="0" v-if="modal === 5">
      <div class="modal-pdv-content">
        <div class="container-fluid p-0">
          <h6 class="font-weight-bold text-center mb-0">Taxas de entrega</h6>
          <hr>
          <div class="px-3">
            <input type="search" class="form-control" id="termZona" v-model="termZona" @keyup="pesquisarZonas" placeholder="Pesquisar"
            @keyup.down="$helpers.focusElement('zona0')">
          </div>
          <div class="height-75 py-2">
            <div class="mx-3">
              <a href="javascript:" tabindex="0" class="d-block py-2 border-bottom px-1 py-3 text-decoration-none text-dark"
                 v-for="(z, index) in zonasSearch" :id="`zona${index}`" @click="selecionarZona(z)"
                 @keyup.enter.prevent="selecionarZona(z)"
                 @keyup.down="$helpers.focusElement('zona' + (index + 1))"
                 @keyup.up="index > 0 ? $helpers.focusElement('zona' + (index - 1)) : $helpers.focusElement('termZona')">
                {{z.texto}}
              </a>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="closeModal('btnPagOutros')">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
        </div>
      </div>
    </div>

    <editar-pagamento ref="editarPag" :formas_pagamento="formas_pagamento" @salvar="salvarPagamento"/>
    <caixa ref="finCaixa" is-pdv="true" @finalizarVenda="finalizaVenda()"/>
  </div>
</template>

<script>
  import Caixa from './Caixa'
  import IconDelete from "../../../components/pdv/IconDelete";
  import Tooltip from "@/components/commons/Tooltip";
  import ValidarVoucher from "@/views/comanda/pdv/ValidarVoucher";
  import EditarPagamento from "@/views/comanda/pdv/EditarPagamento";

  export default {
    name: "finalizar",
    components: {EditarPagamento, ValidarVoucher, Tooltip, IconDelete, Caixa},
    props: ['comanda', 'totalComanda', 'modalCaixa'],

    data() {
      return {
        token: '',
        modal: 0,
        modificou: false,
        modalOpenCaixa: '',
        caixa: '',
        formas_pagamento: [],
        pagamentosCartao: [],
        pagamentosPix: [],
        btnFinalizar: false,
        load: false,

        taxa: 0,
        desconto: 0,
        qtdDividir: '',
        dividir: false,
        percent: 0,
        hasPercent: false,

        obs_pagamento: "",
        forma_pagamento: '',
        valor_pagamento: 0,
        termPagamento: '',
        searchPagamentos: '',
        pagEdit: null,

        totalPagar: 0,
        totalRecebido: 0,

        dados: {
          pagamentos: [],
          desconto: 0,
          troco: 0,
          frete: 0,
          estacionamento: 0,
          cover: 0,
          taxa_servico: 10,
          id_zona: null
        },

        produtos: [],
        selecionados: [],
        totalSelecionados: 0,
        isPedido: false,
        hasService: false,
        frete: 0,
        estacionamento: 0,
        cover: 0,
        isPedidoEntrega: false,

        termZona: '',
        zonasSearch: []
      }
    },

    methods: {
      buscarFormasPagamento() {
        if (!this.formas_pagamento.length) {
          this.formas_pagamento = (this.$store.state.pagamentos_empresa || []).map(opt => { return { ...opt, _texto: opt.nome_pagamento.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()}});
          const pagamentos = this.$store.state.pagamentos_empresa || [];
          this.pagamentosCartao = pagamentos.filter(p => ['3','4'].includes(p.codigo_fiscal));
          this.pagamentosPix = pagamentos.filter(p => p.codigo_fiscal === '17' && p.categoria !== '5');
        }
      },

      togglePagamento(p) {
        this.forma_pagamento = p;
        this.modal = 1;
        this.incluirPagamentoForm();

        if (!this.btnFinalizar) {
          this.$helpers.selectElement('inserirPagamento');
        }
      },

      selPagamento(p) {
        if (!p) {
          if (this.searchPagamentos.length !== 1) return;
          p = this.searchPagamentos[0];
        }

        this.modal = 1;

        if (this.pagEdit) {
          this.dados.troco = 0;
          this.pagEdit.nome_pagamento = p.nome_pagamento;
          this.pagEdit.id_pagamento = p.id_pagamento;
          this.pagEdit = null;
          this.atualizarCampoPagamento();

        } else {
          this.forma_pagamento = p.id_pagamento;

          if (this.dividir) {
            this.dividirConta();

          } else {
            this.incluirPagamentoForm();
          }
        }
      },

      openOutros() {
        this.searchPagamentos = this.formas_pagamento;
        this.termPagamento = '';
        this.modal = 2;
        this.$nextTick(() => {
          this.$helpers.focusElement('termPagamento');
        });
      },

      editarPagamento(p, detalhar) {
        if (detalhar || p.transacao) {
          this.$refs.editarPag.openEditar({
            index: this.dados.pagamentos.indexOf(p),
            id_pagamento: p.id_pagamento,
            id_voucher: p.id_voucher || null,
            data_vencimento: p.data_vencimento || '',
            observacao: p.observacao,
            transacao: p.transacao || null,
            online: p.online,
            valor: p.valor,
          });

        } else if (!p.id_voucher && !p.online) {
          this.pagEdit = p;
          this.openOutros();

        } else {
          this.$swal('Não é possível editar um' + (p.id_voucher ? ' Voucher' : ' Pagamento Online'));
        }
      },

      salvarPagamento(dados) {
        if (dados.index < this.dados.pagamentos.length) {
          const pagamento = this.dados.pagamentos[dados.index];
          pagamento.id_pagamento = dados.id_pagamento;
          pagamento.nome_pagamento = (this.pagamentos.find(p => p.id_pagamento === pagamento.id_pagamento) || {}).nome_pagamento || '';
          pagamento.data_vencimento = ['2','44'].includes(pagamento.id_pagamento) ? dados.data_vencimento : '';
          pagamento.observacao = dados.observacao;
        }
      },

      pesquisarPagamentos() {
        if (this.termPagamento.trim().length) {
          this.searchPagamentos = this.formas_pagamento.filter(p => p._texto.toLowerCase().includes(this.termPagamento.toLowerCase()));

        } else {
          this.searchPagamentos = this.formas_pagamento;
        }
      },

      openCartao() {
        this.modal = 3;
        this.$nextTick(() => {
          this.$helpers.focusElement(`btnCartao0`);
        })
      },

      openPix() {
        if (this.pagamentosPix.length === 1) {
          this.togglePagamento(this.pagamentosPix[0].id_pagamento);
          return;
        }

        this.modal = 6;
        this.$nextTick(() => {
          this.$helpers.focusElement(`btnPix0`);
        })
      },

      clear() {
        this.$emit('clearVoucher');
        this.totalSelecionados = 0;
        this.selecionados = [];
        this.modificou = false;
        this.totalRecebido = 0;
        this.qtdDividir = 2;
        this.btnFinalizar = false;
        this.dados = {
          pagamentos: [],
          desconto: 0,
          troco: 0,
          frete: 0,
          estacionamento: 0,
          cover: 0,
          id_zona: null,
          taxa_servico: 0
        };
      },

      openModal() {
        this.buscarFormasPagamento();
        this.clear();

        if (!this.formas_pagamento.length) {
          this.$swal("Não existem formas de pagamentos cadastradas no sistema!");
          return;
        }

        this.dados.troco = this.comanda.troco && this.comanda.troco ? this.comanda.troco : 0;
        this.dados.desconto = parseFloat(this.comanda.desconto || '0');
        this.desconto = this.dados.desconto;
        this.hasPercent = localStorage.getItem('hasPercent') && this.desconto === 0;

        if (this.isPedidoEntrega) {
          this.dados.frete = this.frete > 0 ? this.frete : 0;
        }

        this.totalPagar = this.normalizeValor(this.totalComanda - parseFloat(this.dados.desconto) + parseFloat(this.dados.frete));

        if (!this.isPedido) {
          if (this.taxa > 0 && ['1','3'].includes(this.comanda.tipo_comanda)) {
            this.toggleTaxaServico(false);
          }

          if (this.comanda.estacionamento > 0) {
            this.estacionamento = parseFloat(this.comanda.estacionamento);
            this.toggleParking();
          }

          if (this.comanda.cover > 0 || (this.comanda.status === '1' && this.cover && this.comanda.qtd_pessoas)) {
            const qtd = (this.comanda.cover <= 0) ? parseInt(this.comanda.qtd_pessoas) : (this.comanda.cover / this.cover);

            for (let i = 0; i < qtd; i++) {
              this.toggleCover(true);
            }
          }

          this.qtdDividir = this.comanda.qtd_pessoas ? parseInt(this.comanda.qtd_pessoas) : 2;
        }

        if (this.comanda.pagamentos.length === 0) {
          this.valor_pagamento = this.totalPagar;
          this.forma_pagamento = '';

        } else {
          if (!this.isPedido) {
            this.comanda.pagamentos.forEach(obj => {
              this.obs_pagamento = obj.observacao;
              this.forma_pagamento = obj.id_pagamento;
              this.valor_pagamento = parseFloat(obj.valor);
              this.incluirPagamento(obj);
            });
          }

          this.atualizarCampoPagamento();
        }

        this.modal = 1;
        this.$nextTick(() => {
          this.$helpers.toggleModal(true, 'modalFinalizar', this.closeModal);
          this.$helpers.focusElement('inserirPagamento', true);
        })
      },

      calcularDesconto() {
        if (this.comanda.status !== '1') {
          return;
        }

        if (this.dados.desconto > 0) {
          this.totalPagar = parseFloat(this.totalPagar) + parseFloat(this.dados.desconto);
          this.dados.desconto = 0;
          this.desconto = 0;
          this.percent = 0;
          this.hasPercent = !!localStorage.getItem('hasPercent');
          this.dados.troco = this.totalRecebido > this.totalPagar ? (this.totalRecebido - this.totalPagar) :  0;
          this.atualizarCampoPagamento();

        } else if (this.desconto > 0 || this.percent > 0) {

          if (this.hasPercent && this.percent > 0) {
            this.desconto = parseFloat((this.totalPagar * this.percent / 100).toFixed(2));
          }

          if ((this.totalPagar - this.desconto) < this.totalRecebido) {
            this.$swal("O valor recebido é maior que o valor total a pagar.");
            return;
          }

          if (this.desconto <= this.totalComanda) {
            this.$helpers.confirmarSenhaAdm(this, () => {
              this.hasPercent = false;
              this.dados.desconto = this.desconto;
              this.totalPagar = this.normalizeValor(this.totalPagar - this.dados.desconto);
              this.atualizarCampoPagamento();
            });
          }
        }
      },

      focusInput(el) {
        if (el.currentTarget) {
          el.currentTarget.select();
        }
      },

      togglePercent() {
        this.percent = 0;
        this.desconto = 0;
        this.hasPercent = !this.hasPercent;
        this.$nextTick(() => {
          if (this.hasPercent) {
            localStorage.setItem('hasPercent', '1');

          } else {
            localStorage.removeItem('hasPercent');
          }

          this.$helpers.focusElement(this.hasPercent ? 'descontoPercent' : 'descontoValor');
        });
      },

      addVoucher(voucher) {
        if (this.dados.pagamentos.find(p => p.id_voucher === voucher.id_voucher)) {
          this.$swal("Voucher já adicionado!");
          return;
        }

        const obs_voucher = `${voucher.ref_voucher} - ${voucher.titulo}`;
        const valor = parseFloat(voucher.valor);

        if (valor > (this.totalPagar - this.totalRecebido)) {
          this.$swal("Não foi possível aplicar o desconto deste voucher pois seu valor é maior que o valor restante desta venda.");
          return;
        }

        this.forma_pagamento = '21';
        this.obs_pagamento = obs_voucher;
        this.incluirPagamentoForm(valor, voucher.id_voucher, voucher.id_tabela_preco);
        this.$swal('Voucher adicionado nas formas de pagamento.\n\nDetalhes: ' + obs_voucher).then(() => {
          this.forma_pagamento = '';
        });
      },

      atualizarCampoPagamento() {
        this.totalSelecionados = 0;
        this.selecionados = [];
        this.valor_pagamento = this.totalRecebido < this.totalPagar ? (this.totalPagar - this.totalRecebido) : 0;
        this.btnFinalizar = (this.totalRecebido === this.totalPagar);

        if (this.isGarcom && this.dados.pagamentos.find(p => p.id_pagamento == 1)) {
          this.btnFinalizar = false;
        }

        if (this.btnFinalizar) {
          this.$helpers.focusElement('btnFinalizar');
        }
      },

      incluirPagamentoForm(valor, id_voucher, id_tabela_preco) {
        this.valor_pagamento = this.normalizeValor(valor ? valor : this.valor_pagamento);

        if (!this.forma_pagamento) {
          this.openOutros();
          return;
        }

        if (parseInt(this.forma_pagamento) !== 1 && (this.valor_pagamento > (this.totalPagar - this.totalRecebido).toFixed(2))) {
          this.$swal("Esta forma de pagamento não permite troco!").then(() => {
            this.$helpers.focusElement('btnDinheiro');
          });

          this.obs_pagamento = '';
          return;
        }

        this.modificou = true;
        this.incluirPagamento({ id_voucher, id_tabela_preco });
        this.produtos.forEach(p => {
          p.disabled = (p.disabled || this.selecionados.includes(p.produto.id_comanda_produto))
        });

        this.atualizarCampoPagamento();
      },

      incluirPagamento(obj) {
        if (!this.valor_pagamento || !this.forma_pagamento) {
          return;
        }

        let pagamento;

        if ((this.totalRecebido + this.valor_pagamento) <= this.totalPagar) {
          this.totalRecebido += this.valor_pagamento;
          pagamento = this.valor_pagamento;

        } else {
          if (parseInt(this.forma_pagamento) === 1) {
            const troco = this.totalRecebido + this.valor_pagamento - this.totalPagar;
            this.dados.troco = (troco > 0 && troco < 200) ? troco : 0;
          }

          pagamento = (this.totalPagar - this.totalRecebido);

          if (pagamento <= 0) {
            return;
          }

          this.totalRecebido += pagamento;
        }

        const objPag = this.pagamentos.find(p => p.id_pagamento === this.forma_pagamento) || {};
        const dados = {
          nome_pagamento: objPag.nome_pagamento || '',
          data_vencimento: obj.data_vencimento || '',
          id_pagamento: this.forma_pagamento,
          transacao: obj.transacao || null,
          observacao: this.obs_pagamento,
          online: obj.categoria === '5',
          valor: pagamento
        };

        if (obj.id_comanda_pagamento) {
          dados.id_comanda_pagamento = obj.id_comanda_pagamento;
        }

        if (obj.id_voucher) {
          dados.id_voucher = obj.id_voucher;
          dados.id_tabela_preco = obj.id_tabela_preco || null;
        }

        this.dados.pagamentos.push(dados);
        this.obs_pagamento = "";
        this.valor_pagamento = 0;
        this.forma_pagamento = obj.id_voucher ? '1' : this.forma_pagamento;
        this.totalRecebido = this.normalizeValor(this.totalRecebido);
      },

      removerPagamento(p) {
        if (p.transacao) {
          this.cancelarTransacao();
          return;
        }

        // if (p.online) {
        //   this.$swal('Não é possível editar um Pagamento Online');
        //   return;
        // }

        let count = 0;
        this.dados.pagamentos.forEach((obj) => {
          if (obj === p) {
            this.totalRecebido -= obj.valor;
            this.dados.pagamentos.splice(count, 1);
            this.modificou = true;
          }
          count++;
        });

        this.dados.troco =  this.totalRecebido > this.totalPagar ? (this.totalRecebido - this.totalPagar) :  0;

        if (!this.dados.pagamentos.length) {
          this.selecionados = [];
          this.produtos.forEach(p => {
            p.disabled = false
          });
        }

        this.atualizarCampoPagamento();
        this.forma_pagamento = '';

        if (!this.btnFinalizar) {
          this.$helpers.focusElement('inserirPagamento');
        }
      },

      cancelarTransacao() {
        this.$swal("Para estornar este pagamento você precisa cancelar a transação no dispositivo em que ele foi pago.");
      },

      finalizaVenda() {
        if (this.load) return;
        this.load = true;

        const id_cliente = this.dados.id_cliente || this.comanda.id_cliente;

        if (this.dados.pagamentos.find(p => ['2','34','44'].includes(p.id_pagamento)) && !id_cliente) {
          this.$swal('Por favor, informe um cliente nesta venda').then(() => {
            this.modal = 4;
            this.$nextTick(() => {
              this.$refs.finCliente.iniciar(null, false);
            });
          });

          this.load = false;
          return;
        }

        if (this.isPedido) {
          if (!this.dados.pagamentos.length) {
            this.$swal({
              text: 'Deseja finalizar este pedido sem selecionar uma forma de pagamento?',
              buttons: ['Não', 'Sim'],
              dangerMode: true
            }).then((res) => {
              if (res) {
                this.$emit('atualizarPedido', this.dados);
                this.closeModal();
              }
            })

          } else {
            this.$emit('atualizarPedido', this.dados);
            this.closeModal();
          }

          this.load = false;
          return;
        }

        if (this.comanda.itens.length <= 0) {
          this.$swal("Atenção!","Você não pode finalizar um venda que não tenha nenhum produto.");
          this.load = false;
          return;
        }

        this.dados.status = (this.totalRecebido < this.totalPagar) ? 1 : 2;

        if (this.isGarcom && this.dados.pagamentos.find(p => p.id_pagamento == 1)) {
          this.dados.status = 1;
        }

        this.dados.id_comanda = this.comanda.id_comanda;
        this.dados.id_cliente = this.dados.id_cliente || this.comanda.id_cliente;
        const selecionados = this.produtos.filter(p => p.disabled);
        this.dados.comanda_cp_pago = selecionados.length ? selecionados.map(p => p.produto.id_comanda_produto) : null;
        this.$store.state.load = true;

        this.$http.post('pdv/finalizar/' + this.token, this.dados)
          .then(response => {
            this.$store.state.load = false;
            this.load = false;

            if (response.data.result) {
              switch (response.data.result) {
                case 'success':
                  this.$emit('atualizarVenda', false, this.dados.status === 2);
                  this.closeModal();

                  if (this.dados.pagamentos.find(p => p.id_pagamento === '44')) {
                    const portal = this.$helpers.getUrlPortal();
                    const contas = response.data.payload?.contas || [];
                    window.open(portal + 'financeiro/receber#' + contas[0]);
                  }

                  break;

                case 'caixa':
                  if (this.isGarcom) {
                    this.$swal("Nenhum caixa aberto. Peça para um atendente abrir o caixa e tente novamente.");
                    return
                  }

                  this.$refs.finCaixa.abrirCaixa(null, 'btnFinalizar');
                  break;

                default:
                  this.$swal("Atenção!", response.data.message);
                  break;
              }
            }

          }, res => {
            this.load = false;
            this.$store.state.load = false;
            this.dados.status = 1;
            this.$swal(res.data?.msg || 'Erro ao enviar, tente novamente').then(() => { this.$helpers.focusElement('btnDinheiro') });
          });
      },

      closeModal(next) {
        if (this.modal === 1) {
          this.modal = 0;
          this.$helpers.toggleModal(false);
          this.$emit('cancelar');

        } else if (this.modal > 1) {
          this.modal = 1;
          this.$helpers.focusElement(next ? next : 'modalFinalizar');
        }

        this.dividir = false;
      },

      selDividir() {
        if (this.comanda.status !== '1') {
          return;
        }

        if (this.valor_pagamento > (this.totalPagar - this.totalRecebido).toFixed(2)) {
          this.$swal("O valor a pagar não pode ser maior que o valor restante!");

        } else if (this.qtdDividir < 2) {
          return;
        }

        this.forma_pagamento = '';
        this.dividir = true;
        this.openOutros();
      },

      dividirConta() {
        this.dividir = false;
        let total = this.valor_pagamento;
        let soma = 0;

        for (let i = 0; i < this.qtdDividir; i++) {
          let pagamento = (total / this.qtdDividir);

          if (parseInt(this.qtdDividir) === (i+1)) {
            pagamento = (pagamento > (this.totalPagar - this.totalRecebido)) ? (this.totalPagar - this.totalRecebido) : (total - soma);
          }

          if (pagamento > 0) {
            soma += this.normalizeValor(pagamento);
            this.incluirPagamentoForm(pagamento);
          }
        }

        this.forma_pagamento = '';
      },

      verificarPDV(status) {
        return parseInt(this.comanda.status) !== status;
      },

      fechar() {
        if (this.comanda.status === '1' && this.modificou) {
          this.$swal({
            title: '',
            text: 'Deseja sair sem salvar os pagamentos?',
            buttons: ['Não','Sim'],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.closeModal();
            }
          })

        } else {
          this.closeModal();
        }
      },

      toggleTaxaServico(remove) {
        const percent = this.taxa > 0 ? this.normalizeValor(this.totalComanda * this.taxa / 100) : 0;

        if (remove) {
          this.totalPagar = this.normalizeValor(this.totalPagar - this.dados.taxa_servico);
          this.dados.taxa_servico = 0;

        } else {
          this.dados.taxa_servico = percent;
          this.totalPagar = this.normalizeValor(this.totalPagar + this.dados.taxa_servico);
        }

        this.atualizarCampoPagamento();
      },

      toggleFrete(focus) {
        if (this.dados.frete > 0) {
          this.totalPagar = this.normalizeValor(this.totalPagar - this.dados.frete);
          this.dados.id_zona = null;
          this.dados.frete = 0;
          this.frete = 0;

          if (focus) {
            this.$nextTick(() => {
              this.$helpers.focusElement('valorFrete');
            });
          }

        } else {
          this.dados.frete = this.frete;
          this.totalPagar = this.normalizeValor(this.totalPagar + parseFloat(this.frete));
        }

        this.atualizarCampoPagamento();
      },

      toggleParking() {
        if (this.dados.estacionamento > 0) {
          this.totalPagar = this.normalizeValor(this.totalPagar - this.dados.estacionamento);
          this.dados.estacionamento = 0;

        } else {
          this.dados.estacionamento = this.estacionamento;
          this.totalPagar = this.normalizeValor(this.totalPagar + parseFloat(this.dados.estacionamento));
        }

        this.atualizarCampoPagamento();
      },

      toggleCover(add) {
        const taxa = this.$store.state.pdv.cover;

        if (add) {
          this.dados.cover += parseFloat(taxa);
          this.totalPagar = this.normalizeValor(this.totalPagar + parseFloat(taxa));

        } else if (this.dados.cover > 0) {
          this.totalPagar = this.normalizeValor(this.totalPagar - parseFloat(taxa));
          this.dados.cover -= parseFloat(taxa);
        }

        this.atualizarCampoPagamento();
      },

      openZonas() {
        this.termZona = '';
        this.zonasSearch = this.zonas;
        this.modal = 5;
        this.$nextTick(() => {
          this.$helpers.focusElement('termZona');
        });
      },

      selecionarZona(zona) {
        this.totalPagar = this.normalizeValor(this.totalPagar - this.dados.frete);
        this.dados.frete = 0;
        this.dados.id_zona = zona.id_zona;
        this.modal = 1
        this.frete = parseFloat(zona.taxa_entrega);
        this.toggleFrete();
      },

      pesquisarZonas() {
        if (this.termZona.trim().length) {
          this.zonasSearch = this.zonas.filter(z => z.texto.toLowerCase().includes(this.termZona.toLowerCase()));

        } else {
          this.zonasSearch = this.zonas;
        }
      },

      normalizeDivisoes(p) {
        let divisoes = [];
        p.forEach(obj => {
          divisoes.push(obj.nome_produto)
        });

        return divisoes.join(", ");
      },

      selecionarCliente(dados) {
        this.modal = 1;

        if (dados) {
          this.dados.id_cliente = dados.id_cliente;
          this.finalizaVenda();
        }
      },

      normalizeValor(valor) {
        return parseFloat(valor.toFixed(2));
      },

      changeSelecionados(p) {
        let valor = parseFloat(p.valor_total);
        let percent = 0;

        if (['1','3'].includes(this.comanda.tipo_comanda) && this.dados.taxa_servico > 0) {
          percent = this.normalizeValor(valor * this.taxa / 100);
          valor += percent;
        }

        if (this.selecionados.includes(p.id_comanda_produto)) {
          this.selecionados = this.selecionados.filter(s => s !== p.id_comanda_produto);
          this.totalSelecionados -= valor;

        } else {
          this.selecionados.push(p.id_comanda_produto)
          this.totalSelecionados += valor;
        }

        if (this.totalSelecionados > 0) {
          this.valor_pagamento = this.totalSelecionados;

        } else {
          this.atualizarCampoPagamento();
        }
      },

      openFinalizar() {
        if (!this.comanda.itens.length) {
          this.$swal("Esta venda não possui nenhum item para ser fechada");
          return;
        }

        this.selecionados = this.comanda.pagos || [];
        this.produtos = this.comanda.itens.map(p => {
          return {
            produto: p.produto,
            divisoes: p.divisoes,
            quantidade: p.quantidade,
            id_voucher: p.produto.id_voucher,
            valor_total: p.valor_total,
            nome_cliente: p.nome_cliente,
            disabled: this.selecionados.includes(p.produto.id_comanda_produto)
          }
        });

        this.isPedido = false;
        this.isPedidoEntrega = this.comanda.tipo_comanda === '2';
        this.frete = this.isPedidoEntrega ? parseFloat(this.comanda.frete || '0') : 0;
        this.taxa = this.$store.state.pdv.taxa_servico;
        this.hasService = (this.taxa > 0);
        this.estacionamento = this.$store.state.pdv.estacionamento;
        this.cover = this.$store.state.pdv.cover;
        this.openModal();
      },

      finalizarPedido(dados) {
        this.produtos = [];
        this.taxa = 0;
        this.estacionamento = 0;
        this.cover = 0;
        this.isPedido = true;
        this.hasService = false;
        this.isPedidoEntrega = dados.tipo_pedido === '1';
        this.frete = 0;
        this.produtos = dados.produtos.map(p => {
          return {
            produto: p.produto,
            divisoes: p.divisoes,
            quantidade: p.quantidade,
            id_voucher: p.id_voucher,
            valor_total: p.valor_total
          }
        });

        if (this.isPedidoEntrega) {
          if (dados.frete > 0) {
            this.frete = dados.frete;

          } else {
            let zona = dados.id_zona ? this.$store.state.zonasEntrega.find(z => z.id_zona == dados.id_zona) : null;
            dados.id_zona = zona ? dados.id_zona : null;
            this.frete = zona ? (zona.taxa_entrega ? parseFloat(zona.taxa_entrega) : 0) : this.$store.state.pdv.valor_frete;
          }

        } else {
          dados.id_zona = null;
        }

        this.openModal();
        this.dados.id_cliente = dados.id_cliente || null;
        this.dados.id_zona = dados.id_zona;

        if (dados.pagamentos.length) {
          dados.pagamentos.forEach(pag => {
            this.obs_pagamento = pag.observacao;
            this.forma_pagamento = pag.id_pagamento;
            this.valor_pagamento = parseFloat(pag.valor);
            this.incluirPagamento(pag);
          });
        }
      }
    },

    mounted() {
      this.token = localStorage.getItem('key');
    },

    computed: {
      zonas() {
        return this.$store.state.zonasEntrega
      },

      pagamentos() {
        return this.$store.state.pagamentos;
      },

      impostoNfe() {
        return this.$store.state.pdv.json_config.imposto_nfe === '1';
      },

      isGarcom() {
        return this.$store.state.dataUser.isGarcom;
      }
    },

    filters: {
      qtd(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed();
        }
      },

      medida(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(3) + " kg";
        }
      }

    }
  }
</script>

<style scoped>
.height-90 {
  height: calc(100vh - 200px);
}

.height-50 {
  height: calc(100vh - 348px);
}

.img-pagamento {
  width: 28px;
  height: 18px;
  object-fit: contain;
}

.btn-pagamento {
  height: 92px;
}

.modalCaixa {
  z-index: 2000;
}

@media (max-width: 991px) {
  .card-pagamento {
    border: 1px solid #dddfeb;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    background-color: var(--light);
  }

  .height-50 {
    overflow: hidden;
  }
}

@media (max-width: 575px) {
  .card-pagamento .btn {
    margin-top: 8px;
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
  }
}
</style>
